export default ['$rootScope', caret]

export function caret(root) {
  const getChildNodeWithCaretIndex = (range, editableDiv) => {
    let childNodeWithCaretIndex

    if (editableDiv === range.commonAncestorContainer.parentElement) {
      //  text element
      childNodeWithCaretIndex = [].indexOf.call(
        editableDiv.childNodes,
        range.commonAncestorContainer
      )
    } else {
      //  DFN element - inspect its child nodes to find the text element where the caret currently is
      for (let i = 0; i < editableDiv.childNodes.length; i++) {
        let currChildNode = editableDiv.childNodes[i]

        let searchIndex = [].indexOf.call(
          currChildNode.childNodes,
          range.commonAncestorContainer
        )
        if (searchIndex > -1) {
          childNodeWithCaretIndex = i
          break
        }
      }
    }

    return childNodeWithCaretIndex
  }
  this.getCaretPosition = (editableDiv, contentElementChildNodes) => {
    const selection = window.getSelection()
    let caretPosition = -1
    let childNodeWithCaretIndex = -1

    if (selection && selection.rangeCount) {
      const range = selection.getRangeAt(0)
      caretPosition = range.endOffset

      if (editableDiv.nodeName === 'A') {
        childNodeWithCaretIndex = [].indexOf.call(
          contentElementChildNodes,
          editableDiv
        )
      } else {
        childNodeWithCaretIndex = getChildNodeWithCaretIndex(range, editableDiv)
      }
    }

    return {
      caretPosition: caretPosition,
      childNodeWithCaretIndex: childNodeWithCaretIndex,
    }
  }

  this.setCaretPosition = (
    contentElementIndex,
    caretPosition,
    childNodeWithCaretIndex,
    contentElementChildNodes
  ) => {
    if (
      window.getSelection &&
      caretPosition >= 0 &&
      childNodeWithCaretIndex >= 0
    ) {
      let childNodeContainingCaret =
        contentElementChildNodes[childNodeWithCaretIndex]

      while (
        childNodeContainingCaret &&
        childNodeContainingCaret.nodeName !== '#text'
      ) {
        childNodeContainingCaret = childNodeContainingCaret.childNodes[0]
      }

      if (childNodeContainingCaret) {
        try {
          const sel = window.getSelection()
          let range = document.createRange()
          range.setStart(childNodeContainingCaret, caretPosition)
          range.collapse(true)
          sel.removeAllRanges()
          sel.addRange(range)
        } catch (e) {
          console.log('Problem setting cursor, user did not see this error', e)
        }
      }
    }
  }
}
